import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

Turbo.StreamActions.full_page_redirect = function() {
  document.location = this.getAttribute("target")
}
